<template>
    <svg xmlns="http://www.w3.org/2000/svg" data-name="Livello 1" viewBox="0 0 24 24" fill="currentColor"><path d="M4.3 15.85V2.37h15.41v13.48h-3.55l-.96 1.93H8.82l-.96-1.93H4.31Zm11.25-.96h3.19V3.33H5.26v11.56h3.19l.96 1.93h5.18l.96-1.93Zm3.19 1.93h.96v4.82H4.3v-4.82h.96v3.85h13.48v-3.85ZM7.18 6.22h9.63v-.96H7.18v.96Zm9.64 2.89H7.18v-.96h9.63v.96ZM7.18 12h9.63v-.96H7.18V12Z" /></svg>
</template>

